import React from 'react'
import PropTypes from 'prop-types'
import { compose, pure } from 'recompose'
import TextLabel, { SizeType, ColorType, WeightType } from '../../atoms/TextLabel/TextLabel'
import EditorLimitTextField from '../../molecules/EditorLimitTextField/EditorLimitTextField'
import './EditFirstPage.css'

const EditFirstPage = ({ eventTitle, onChangeEventTitleText, choiceFirstImage, onChangeFirstImage, errorMessage }) => (
  <div styleName="container">
    <ul styleName="tabs_labels">
      <li styleName="tabs_li active">
        <div styleName="tab">
          <p styleName="tabText">概要</p>
        </div>
      </li>
    </ul>
    <div styleName="section">
      <p styleName="title">タイトル</p>
      <EditorLimitTextField
        index={0}
        text={eventTitle}
        limitLength={30}
        choiceImage={choiceFirstImage}
        showLimitCount={true}
        showImage={true}
        showRadioButton={false}
        onChangeText={onChangeEventTitleText}
        onChangeImage={onChangeFirstImage}
      />
      <TextLabel size={SizeType.XTINY} color={ColorType.ERROR} weight={WeightType.LIGHT}>
        {errorMessage}
      </TextLabel>
    </div>
  </div>
)

EditFirstPage.propTypes = {
  eventTitle: PropTypes.string,
  choiceFirstImage: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onChangeFirstImage: PropTypes.func,
  onChangeEventTitleText: PropTypes.func,
  errorMessage: PropTypes.string
}

export default compose(pure)(EditFirstPage)
